import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import MaskedInput from "react-text-mask";

import getInputErrorClass from "utils/getInputErrorClass";

import { INPUT_MASK_PLACEHOLDER_CHAR } from "./masks";
import InputErrorMessage from "../InputErrorMessage";

export const INPUT_DEFAULT_CLASSES = "text-lg text-black border border-grey-dark outline-none focus:border-secondary w-full rounded-sm pl-2 py-3 mt-1";

function Input({
  error,
  label,
  labelClass,
  formupData,
  mask,
  className,
  reserveErrorSpace = true,
  ...rest
}) {
  const inputClasses = classNames(INPUT_DEFAULT_CLASSES, className, getInputErrorClass(error));

  return (
    <label htmlFor={rest.id} className={classNames("text-sm text-dark", labelClass)}>
      {label}

      {
        !mask
        && (
          <input
            {...rest}
            className={inputClasses}
          />
        )
      }
      {
        mask
        && (
          <MaskedInput
            {...rest}
            className={inputClasses}
            placeholderChar={INPUT_MASK_PLACEHOLDER_CHAR}
            mask={mask}
          />
        )
      }

      <InputErrorMessage className="mt-1/2 leading-tight">
        { error && formupData?.errorMessage && formupData?.errorMessage }
        { reserveErrorSpace && <>&nbsp;</> }
      </InputErrorMessage>
    </label>
  );
}

Input.defaultProps = {
  label: null,
  error: undefined,
  formupData: undefined,
};

Input.propTypes = {
  label: PropTypes.string,
  error: PropTypes.bool,
  formupData: PropTypes.shape({
    errorMessage: PropTypes.string,
  }),
};

export default Input;
